<script setup lang="ts">

    export interface Props {
        href ?: string,
        target ?: string,
        label : string
    }

    const props = withDefaults(defineProps<Props>(), {
        href: '#',
        target: '_blank'
    });

</script>

<template>
    <a class="news-component-button" 
        :href 
        :target 
    >
        <slot name="left">
            <div />
        </slot>
        <slot name="label">
            <div>{{ label }}</div>
        </slot>
        <slot name="right">
            <div />
        </slot>
    </a>
</template>

<style>
    .news-component-button {

        background-color: var(--bmePrimary);
        color: var(--bmeWhite);

        font-family: var(--bmeFontFamily);
        font-size: var(--bmeBody2FontSize);
        line-height: var(--bmeBody2LineHeight);
        font-weight: var(--bmeBody2FontWeight);

        border-radius: 2rem;
        min-height: var(--bmeBody2LineHeight);
        padding: 0.5rem 0.75rem;

        text-decoration: none;

        display: inline-grid;
        grid-template-columns: auto minmax(0, 1fr) auto;
        align-items: center;
        gap: 0.25rem;

        &:hover {
            background-color: var(--bmePrimaryHover);
        }

    }
</style>